import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './ReviewGrid.scss';
import { ReviewRating } from './ReviewRating';
import { getThingtestingImageUrl } from '../../Helpers/thingtesting_helpers';
import { truncateToWords } from '../../Helpers/text_helpers';
import ReviewModal from '../Modals/ReviewModal';

export const ReviewGrid = ({ reviews }) => {
  if (!reviews.length) return null;

  const [selectedReview, setSelectedReview] = useState(null);

  const handleClick = (e, review) => {
    e.preventDefault();
    setSelectedReview(review);
  };

  return (
    <div className='review-grid'>
      {reviews.slice(0, 5).map(review => (
        <a
          key={review.id}
          className='review-grid-item'
          href={`https://thingtesting.com/brands/${review.brand.slug}/reviews/${review.id}`}
          target='_blank'
          rel='noopener noreferrer'
          onClick={e => handleClick(e, review)}
        >
          <div className='review-author'>
            <div className='review-avatar-container'>
              <img src={getThingtestingImageUrl(review.author.avatarFullPath, 'w-128,h-128')} alt='' />
            </div>
            <div className='review-name'>{review.author.fullName}</div>
          </div>
          <div className='review-text'>{truncateToWords([review.bodyPositive, review.bodyNegative].filter(Boolean).join(' '), 40)}</div>
          <div className='review-rating-container'>
            <ReviewRating rating={review.stars} />
          </div>
        </a>
      ))}

      {selectedReview && (
        <ReviewModal
          review={selectedReview}
          otherReviews={reviews}
          visible={true}
          close={() => setSelectedReview(null)}
          onNavigate={review => setSelectedReview(review)}
        />
      )}
    </div>
  );
};

ReviewGrid.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      brand: PropTypes.shape({
        slug: PropTypes.string.isRequired
      }).isRequired,
      author: PropTypes.shape({
        fullName: PropTypes.string.isRequired,
        avatarFullPath: PropTypes.string.isRequired
      }).isRequired,
      bodyPositive: PropTypes.string,
      bodyNegative: PropTypes.string,
      stars: PropTypes.number.isRequired
    })
  ).isRequired
};
